import { List } from "lodash";
import * as Common from "../../../Common/modules";
import * as Models from "../../../Models";
import { InvoiceDetails } from "../../../Models/ProcessReview/invoiceSubmission";
import * as Services from "../../../Services";


export interface IRespondToProcessReviewScope extends ng.IScope {
  respondToProcessReviewCtrl: RespondToProcessReviewController;
  documentUploadModel: Models.DocumentManagement.CustomerDocumentUploadModel.IDocumentUploadModel;
}

export class RespondToProcessReviewController {

  public static $inject = [
    "$state",
    "$scope",
    "$modalInstance",
    "ProcessReviewInvoiceApiClient",
    "approving",
    "igsCustomerNumber",
    "invoiceDetails",
    "processReviewType",
    "igs.maskingService"];

  public formSubmitted: boolean = false;
  public rejectionReason: string;

  constructor(
    public $state: angular.ui.IStateService,
    public $scope: IRespondToProcessReviewScope,
    public $modalInstance: angular.ui.bootstrap.IModalServiceInstance,
    protected processReviewInvoiceApiClient: Services.ProcessReviewInvoiceApiClient.IProcessReviewInvoiceApiClient,
    public approving: boolean,
    public igsCustomerNumber: string,
    public invoiceDetails: InvoiceDetails,
    private processReviewType: string,
    public maskingService: any,
    public documentUploadModel: Models.DocumentManagement.CustomerDocumentUploadModel.IDocumentUploadModel,
    public uploadProgressPercent: number,
    public uploadInvalid = false,
  ) {
    $scope.respondToProcessReviewCtrl = this;
    this.maskingService = maskingService;
  }

  public submit = () => {
    this.formSubmitted = true;
    this.maskingService.mask();
    this.processReviewInvoiceApiClient.respondToProcessReview(
      this.igsCustomerNumber,
      this.approving,
      this.rejectionReason,
      this.documentUploadModel ? this.documentUploadModel.file : null,
      this.processReviewType)
      .then(() => {
        this.maskingService.unmask();
        this.$modalInstance.close(true);
      }), () => {
        this.maskingService.unmask();
        toastr.error("There was an issue responding to this invoice. Please try again later.", "ERROR");
        this.formSubmitted = false;
      };
  }

  public closeModal = () => {
    this.$modalInstance.close(false);
  }
}
